<template>
<div class="chapter">
<div class="inner_page">
<p><a id="ata"></a></p><a id="ata">
</a><div class="fmtx1"><a id="ata"><b>Tom Holt</b> was born in London in 1961. At Oxford he studied bar billiards, ancient Greek agriculture and the care and feeding of small, temperamental Japanese motorcycle engines; interests which led him, perhaps inevitably, to qualify as a solicitor and emigrate to Somerset, where he specialised in death and taxes for seven years before going straight in 1995. Now a full-time writer, he lives in Chard, Somerset, with his wife, one daughter and the unmistakable scent of blood, wafting in on the breeze from the local meat-packing plant. For more information about Tom Holt visit </a><a href="http://www.tom-holt.com" target="_blank">www.tom-holt.com</a></div>
<div> <br/></div><div> <br/></div><div class="fmtx1">Find out more about other Orbit authors by registering for the free monthly newsletter at <a href="http://www.orbitbooks.net" target="_blank">www.orbitbooks.net</a></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tomh_9780748113576_oeb_ata_r1.vue?3c7b3da1